import * as yup from 'yup';
import { organizationNumberValidations } from '../../../../../util/validation';

export const formSchema = yup.object().shape({
  pensionCompany: yup.object().shape({
    shortName: yup.string().required('Required'),
    companyName: yup.string().required('Required'),
    clientNumber: yup.string().required('Required'),
    contractNumber: yup.string().required('Required'),
    description: yup.string(),
    organizationNumber: organizationNumberValidations(false),
    vatNumber: yup.string(),
    bankgiroNumber: yup.string(),
    plusgiroNumber: yup.string(),
    status: yup.string(),
    collectiveAgreement: yup.boolean().default(false),
  }),
  contactInformation: yup.object().shape({
    address: yup.string(),
    city: yup.string(),
    phone: yup.string(),
    fax: yup.string(),
    postalCode: yup.string(),
    email: yup.string().email('Invalid Email'),
  }),
  connection: yup.object().shape({
    connectionTypeAPI: yup.object().shape({
      isChecked: yup.boolean().default(true),
      apiKey: yup.string(),
      serviceKey: yup.string(),
    }),
    connectionTypeFile: yup.object().shape({
      isChecked: yup.boolean().default(false),
      email: yup.string().email('Invalid Email'),
      type: yup.string(),
    }),
  }),
  pensionManagerPlans: yup.object().shape({
    providerDescription: yup.string(),
    correctoPartner: yup.boolean(),
    plans: yup.array().of(
      yup.object().shape({
        planName: yup.string().required('Required'),
        providerDescription: yup.string(),
        order: yup.number(),
        documents: yup.array().of(
          yup.object().shape({
            text: yup.string(),
            documentLink: yup.string(),
          }),
        ),
        costSpecification: yup.object().shape({
          specItems: yup.array().of(
            yup.object().shape({
              title: yup.string(),
              fee: yup.mixed(),
              exemptionLetter: yup.mixed(),
            }),
          ),
          description: yup.string(),
        }),
      }),
    ),
  }),
});
